/**
 * Copyright 2022 Nordcloud Oy or its affiliates. All Rights Reserved.
 */

import * as React from "react";
import styled from "styled-components";
import { Button, ButtonProps } from "@nordcloud/gnui";

type StyledButtonProps = ButtonProps & {
  extraSize: "small" | "large";
};

type PopoverTriggerProps = {
  size: "small" | "large";
  disabled: boolean;
};

const StyledButton = styled(Button)<StyledButtonProps>`
  transform: ${(props) =>
    props.extraSize === "large" ? "scale(1.25)" : "inherit"};
  opacity: ${(props) => (props.extraSize === "large" ? "0.6" : "inherit")};
`;

export function PopoverTrigger({ size, disabled }: PopoverTriggerProps) {
  return (
    <StyledButton
      extraSize={size}
      disabled={disabled}
      severity="low"
      icon="menu"
      size="md"
    />
  );
}
